export default "__VITE_ASSET__DrujUvBL__"